import React, { Component, ReactElement, useState } from "react";

import PageLayout from '../../components/layout/PageLayout'
import { ThemeProps } from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";
import "./impressum.css";
import SitemapImg from "./sitemapImg";
import { useTranslation } from "react-i18next";

type Props = { theme: ThemeProps, onClickCallParentLevelMethod?: (event: React.MouseEvent<HTMLAnchorElement>) => void, }
export default function CookiePolicy({ theme, onClickCallParentLevelMethod }: Props) {


	const { t, i18n } = useTranslation();

	return (
		<PageLayout title="Home" theme={theme}>
			<div className="imprint">
				<div className="basic-projects">
					<Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
						<div className="projects-heading-div">
							<div className="imprint-heading-img-div">
								{/* <img
											src={require(`../../assests/images/${projectsHeader["avatar_image_path"]}`)}
											alt=""
										/> */}
								<SitemapImg theme={theme} />
							</div>
							<div className="projects-heading-text-div">
								<h1 className="projects-heading-text">{t("cookie.title")}</h1>
								<p className="projects-header-detail-text subTitle">
									{t("cookie.description")}
								</p>
							</div>
						</div>
					</Fade>
				</div>
			</div>


			<div className="contact-form-div imprint">
				<h1 className="d-flex justify-content-center">{t("cookie.title")}</h1>

				<div className="row d-flex align-items-center justify-content-center h-100">
					<div className="col-md-3 col-lg-3 col-xl-3"></div>
					<div className="col-md-6 col-lg-6 col-xl-6 ">
						<div className="float-end"></div>

						<div className="cc_commands" style={{ textAlign: "right" }}>
							<a id="cc_edit" href="#" onClick={onClickCallParentLevelMethod}>Cookie-Einstellungen bearbeiten</a>
						</div>

						<h2>Was ist ein Cookie?</h2>
						<p>Ein Cookie ist eine kleine Textdatei, die beim Zugriff auf eine Website auf Ihr Gerät heruntergeladen wird.</p>
						<h2>Was machen Cookies?</h2>
						<p>Auf diese Weise kann die Website Ihr Gerät erkennen und einige Informationen zu Ihren Einstellungen oder früheren Aktionen speichern, damit Websites funktionieren oder effizienter arbeiten und den Betreibern der Website Informationen zur Verfügung gestellt werden. Kurz gesagt, Cookies helfen uns, Ihnen beim Surfen auf unserer Website eine gute Nutzererfahrung zu bieten, und ermöglichen uns auch, unsere Website zu verbessern.</p>
						<h2>Sind alle Cookies gleich?</h2>
						<p>Nicht wirklich.</p>
						<p>Cookies können je nach Dauer oder Herkunft unterschiedlich sein.</p>
						<p>1. Es gibt zwei Arten von Speicherdauer für Cookies:</p>
						<ul>
							<li>Session Cookies, die nur vorübergehend sind und nur im geöffneten Zustand Ihres Browsers gespeichert werden. Sobald der Browser geschlossen wird, wird das Cookie aus Ihrem Browserverlauf entfernt.</li>
							<li>Permanente Cookies bleiben bis zu ihrem Ablaufdatum erhalten. Diese Cookies werden nicht entfernt, wenn der Browser geschlossen wird, sondern nach Erreichen eines Ablaufdatums. Die Dauer richtet sich nach dem Zweck der Cookies. Sie können diese Cookies auch manuell löschen.</li>
						</ul>
						<p>2. Cookies können aus verschiedenen Quellen stammen:</p>
						<ul>
							<li>First-Party Cookies werden von der Website erstellt, die Sie besuchen.</li>
							<li>Third-Party Cookies werden von Drittanbietern erstellt und vom Eigentümer der Website für verschiedene Zwecke platziert.</li>
						</ul>
						<p>Weitere Informationen zu Cookies, einschließlich Informationen darüber, welche Cookies auf Ihrem Gerät gesetzt wurden und wie Sie diese verwalten und löschen, finden Sie unter www.aboutcookies.org und www.youronlinechoices.eu.</p>
						<h2>Web Beacons</h2>
						<p>Web Beacons (auch als Internet-Tags, Pixel-Tags und Clear GIFs bezeichnet) sind in der Regel transparente Grafiken, die auf einer Website platziert werden. Web Beacons werden in Kombination mit Cookies verwendet, um Aktionen der Besucher unserer Website zu erkennen. Wir können Beacons verwenden, um Informationen wie die IP-Adresse des Geräts abzurufen, der die Seite heruntergeladen hat, auf der das Beacon angezeigt wird, oder die URL der Seite, auf der das Beacon angezeigt wird, den Zeitpunkt, zu dem die Seite aufgerufen wurde, und die Version des Browsers, die verwendet wurde um eine Seite zu besuchen.</p>
						<h2>IP-Adressen und URLs</h2>
						<p>Eine IP-Adresse ist eine eindeutige Kennung, mit der bestimmte Geräte identifiziert werden und über das Internet kommunizieren können. Wenn Sie unsere Website besuchen, wird möglicherweise die IP-Adresse des Geräts angezeigt, mit dem über die oben genannten Web Beacons eine Verbindung zum Internet hergestellt wurde. Diese Informationen werden verwendet, um den allgemeinen physischen Standort des Geräts zu bestimmen. Wir können diese Informationen verwenden, um die Art und Weise zu ändern, wie wir unsere Websites präsentieren, um Ihren Besuch zu verbessern.</p>
						<p>Eine URL (Uniform Resource Locator) ist eine eindeutige Kennung oder Adresse für jede Ressource im Internet. Dies ist beispielsweise die Adresse für die Webseite, die Sie besuchen. Wir verwenden diese Informationen, um zu sehen, welche Seiten besucht werden und wie die Benutzer durch unsere Website navigieren.</p>

					</div>
					<div className="col-md-3 col-lg-3 col-xl-3"></div>
				</div>

			</div>

		</PageLayout>
	);
}